import { get } from 'lodash/fp';

export const getSettingsPos = get('settings.POS');
